module.exports = __webpack_public_path__ + "img/base_nature_ile.0a58cf26.svg";